import React, {useEffect, useState} from "react";
import ApiService from "../../services/ApiService";
import {useAppContext} from "../../context/AppContext";

export default function InfoTab({data}) {
    const {selectedErrorId, selectedOperation} = useAppContext()
    const [info, setInfo] = useState('')

    const getInfoPanel = async ({topic, code}) => {
        const res = await ApiService.RasCheck.GetMessageInfo({
            messageCode: code,
            topic: topic
        })

        if(res.success) {
            setInfo(res.data)
        }
    }

    useEffect(() => {
        getInfoPanel({topic: selectedOperation?.key, code: selectedErrorId})
    }, [selectedErrorId]);

    return (
        <>
            <div style={{width: '100%', padding: 8}}>
                {
                    info && (
                        <div id={'info-panel'} dangerouslySetInnerHTML={{__html: info}}>

                        </div>
                    )
                }
            </div>
        </>
    )
}